import type { Space } from '@cocoonspace/sdk-js/types/space'
import type { ComponentProps } from 'react'
import { cn } from '@cocoonspace/ui/lib/utils'
import { UsersIcon } from 'lucide-react'

export const SpaceCapacity = ({
	space,
	className,
	...props
}: {
	space: Pick<Space, 'capacity'>
} & ComponentProps<'div'>) => (
	<div
		className={cn('flex flex-row items-center', className)}
		data-testid='space-capacity'
		{...props}
	>
		<UsersIcon
			className='mr-1'
			size={14}
		/>

		{space.capacity}
	</div>
)
